import React from "react";
import { Link } from "react-router-dom";

export const isInAppPath = (href) => typeof href === "string" && href.startsWith("/") && !href.startsWith("//");

const AppLink = React.forwardRef(({ href, children, ...rest }, ref) =>
  isInAppPath(href) ? (
    <Link ref={ref} to={href} {...rest}>
      {children}
    </Link>
  ) : (
    <a ref={ref} href={href} {...rest}>
      {children}
    </a>
  ),
);

export default AppLink;
